/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import "./Notification.css";
import React from "react";
import * as notSelectors from "../../../store/notification/selector";
import * as authSelectors from "../../../store/auth/selectors";
import * as companySelectors from "../../../store/company/selector";
import * as notActions from "../../../store/notification/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  ADMIN_ROLE,
  SUPER_ADMIN_ROLE,
  USER_ROLE,
  SALES_MAIL,
  STATUS_DISABLED,
  CONTRACT_TYPE,
} from "../../../constants/Constants";
import { routes } from "../../utilities/routes";
import { Routes } from "../../../app/Utilities";
import { messages } from "../../utilities/messages";
import withRouter from "../../../app/common/WithRouter/withRouter";
import { CUSTOMER_ADMIN } from "../../../app/Constants/Constants";
class NotificationContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      userRestPassNotify: false,
      notifications: {
        pendingUser: null,
        trial: null,
      },
    };
    this.routeToAdmin = this.routeToAdmin.bind(this);
    this.handleWSData = this.handleWSData.bind(this);
    this.routeToPaymentDetails = this.routeToPaymentDetails.bind(this);
    this.routeToQuickPay = this.routeToQuickPay.bind(this);
    setInterval(
      /* istanbul ignore next */
      () => {
        if (!this.state.notifications.pendingUser) {
          this.handleWSData();
        }
      },
      10000 * 6 * 3,
    );
  }
  /* istanbul ignore next */
  routeToAdmin() {
    this.props.router.history.push(`${Routes.users}`, { userNotify: true });
  }
  /* istanbul ignore next */
  routeToPaymentDetails() {
    this.props.router.history.push(`${routes.admin_settings}?dt=3&vt=5`);
  }
  /* istanbul ignore next */
  routeToQuickPay() {
    this.props.router.history.push(routes.payment);
  }
  /* istanbul ignore next */
  dismiss(type) {
    this.props.DismissNotification(type);
  }
  /* istanbul ignore next */
  componentDidMount() {
    this.props.ResetDismissNotification();
  }
  /* istanbul ignore next */
  handleWSData() {
    /* istanbul ignore if */
    if (
      this.props.auth &&
      this.props.auth.user &&
      this.props.auth.user.roleName !== USER_ROLE
    ) {
      this.props.FetchPendingUserNotif(
        this.props?.defaultCompany?.companyuuid
          ? this.props.defaultCompany.companyuuid
          : this.props.auth.user.companyuuid,
        this.props.auth.user.user_id,
      );
    }
  }
  /* istanbul ignore next */
  userTrialMessage(trialPercentage) {
    if (trialPercentage >= 80)
      return messages.trial_period.user.less_than_100_msg;
    else if (trialPercentage >= 50)
      return messages.trial_period.user.less_than_80_msg;
    else return messages.trial_period.user.less_than_50_msg;
  }
  /* istanbul ignore next */
  adminTrialMessage(trialPercentage) {
    if (trialPercentage >= 80)
      return messages.trial_period.admin.less_than_100_msg;
    else if (trialPercentage >= 50)
      return messages.trial_period.admin.less_than_80_msg;
    else return messages.trial_period.admin.less_than_50_msg;
  }
  /* istanbul ignore next */
  componentWillUnmount() {
    this.setState({ userRestPassNotify: false });
  }
  /* istanbul ignore next */
  componentDidUpdate(prevProps) {
    if (this.props.auth && this.props.auth.user) {
      if (this.props.auth.error !== prevProps.auth.error) {
        if (
          this.props.auth.error == messages.could_not_send_reset_password_link
        )
          this.setState({ userRestPassNotify: true });
      }
      if (this.props.auth.user?.user_id !== prevProps.auth.user?.user_id) {
        if (
          this.props.auth.user.roleName !== USER_ROLE &&
          this.props.dismissedNotifications.indexOf("pendingUser") === -1
        ) {
          this.props.FetchPendingUserNotif(
            this.props?.defaultCompany?.companyuuid
              ? this.props.defaultCompany.companyuuid
              : this.props.auth.user.companyuuid,
            this.props.auth.user.user_id,
          );
        }
        if (this.props.dismissedNotifications.indexOf("trial") === -1) {
          this.props.FetchTrialPeriodNotif(this.props.auth.user.companyuuid);
        }
      }
      if (
        this.props.trialPeriodNotification !==
          prevProps.trialPeriodNotification &&
        this.props.dismissedNotifications.indexOf("trial") === -1
      ) {
        this.setState({
          notifications: {
            ...this.state.notifications,
            trial: this.props.trialPeriodNotification,
          },
        });
      }
      if (
        (this.props.pendingUserNotification !==
          prevProps.pendingUserNotification ||
          this.props.pendingUserNotification !==
            this.state.notifications.pendingUser) &&
        this.props.dismissedNotifications.indexOf("pendingUser") === -1
      ) {
        this.setState({
          notifications: {
            ...this.state.notifications,
            pendingUser: this.props.pendingUserNotification,
          },
        });
      }

      if (
        this.props.dismissedNotifications !== prevProps.dismissedNotifications
      ) {
        let stateObj = {};
        Object.keys(this.state.notifications).forEach((key) => {
          if (this.props.dismissedNotifications.indexOf(key) !== -1) {
            stateObj[key] = null;
          }
        });
        this.setState(
          {
            notifications: { ...this.state.notifications, ...stateObj },
          },
          () => {},
        );
      }
    }
  }
  render() {
    return (
      <div>
        {this.props.auth &&
          this.props.auth.user &&
          this.props.auth.user.customerAccountStatus === STATUS_DISABLED &&
          this.props.auth.user.customerAccountType !== CONTRACT_TYPE && (
            <div
              className={`notif-body deactivate-notif-body ${
                this.props.router.history.location.pathname === routes.payment
                  ? "company-disabled-notify"
                  : ""
              }`}
            >
              <div className="notif-dismiss">
                <p className="notification-bold">
                  Your account is {this.props.auth.user.customerAccountStatus}.
                </p>
                <p className="trial-click notification-change">
                  To continue using Datazoom, please
                  <span
                    onClick={
                      /* istanbul ignore next */
                      () => {
                        this.routeToQuickPay();
                      }
                    }
                  >
                    enter your payment details
                  </span>{" "}
                  or{" "}
                  <a
                    className="trial-click sales-click"
                    href={`mailto:${SALES_MAIL}`}
                  >
                    contact the Datazoom Sales team
                  </a>
                </p>
              </div>
            </div>
          )}
        {this.props.auth &&
          this.props.auth.user &&
          this.state.notifications.pendingUser &&
          this.props.router.location.key &&
          this.state.notifications.pendingUser.success &&
          this.props.router.location.pathname != "/resetpasswordsuccess" && (
            <div className="notif-body">
              <div className="notif-dismiss">
                <p>{this.state.notifications.pendingUser.message} </p>
                <span
                  onClick={
                    /* istanbul ignore next */
                    () => {
                      this.dismiss("pendingUser");
                      this.routeToAdmin();
                    }
                  }
                >
                  Review Requests Now
                </span>
                <span
                  onClick={
                    /* istanbul ignore next */
                    () => {
                      this.dismiss("pendingUser");
                    }
                  }
                >
                  Dismiss
                </span>
              </div>
            </div>
          )}
        {this.props.auth &&
          this.props.auth.user &&
          this.state.notifications.trial &&
          this.state.notifications.trial.success &&
          this.state.notifications.trial.data &&
          this.state.notifications.trial.data.trialDataUsagePercent &&
          this.props.router.location.pathname != "/resetpasswordsuccess" && (
            <div className="notif-body">
              <div className="notif-dismiss">
                {this.props.auth.user.roleName === USER_ROLE &&
                  this.state.notifications.trial.data &&
                  this.state.notifications.trial.data.trialDataUsagePercent && (
                    <p>
                      {this.userTrialMessage(
                        this.state.notifications.trial.data
                          .trialDataUsagePercent,
                      )}
                    </p>
                  )}
                {this.props.auth.user.roleName === ADMIN_ROLE &&
                  this.state.notifications.trial.data &&
                  this.state.notifications.trial.data.trialDataUsagePercent && (
                    <p
                      className="trial-click"
                      onClick={
                        /* istanbul ignore next */
                        () => {
                          // this.dismiss("trial");
                          this.routeToPaymentDetails();
                        }
                      }
                    >
                      {this.adminTrialMessage(
                        this.state.notifications.trial.data
                          .trialDataUsagePercent,
                      )}
                    </p>
                  )}
              </div>
            </div>
          )}
        {this.state.userRestPassNotify && this.props.auth.error !== null && (
          <div className="notif-body-temp-blocked">
            <div className="notif-dismiss">
              <p>
                For your protection, your account has been temporarily blocked
                due to too many password reset requests. Please try again
                tomorrow or contact your administrator.
              </p>
              <span
                onClick={
                  /* istanbul ignore next */ () =>
                    this.setState({ userRestPassNotify: false })
                }
              >
                Dismiss
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    auth: authSelectors.getauth(state),
    pendingUserNotification: notSelectors.getPendingUserNotif(state),
    trialPeriodNotification: notSelectors.getTrialPeriodNotif(state),
    dismissedNotifications: notSelectors.getDismissed(state),
    defaultCompany: companySelectors.getDefaultCompany(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...notActions }, dispatch);
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NotificationContainer),
);
